import Header from '../../../components/Header';
import React, { useEffect, useState, useMemo } from 'react';
import { Box, Typography, Button, Grid, useTheme, IconButton, TextField, InputAdornment, MenuItem, Select, FormControl, useMediaQuery, Dialog, DialogContent, DialogActions } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import SearchIcon from '@mui/icons-material/Search';
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import { getAccount, getAllMarketingData } from '../../../redux/slice/account.slice';

function Account() {
    const isMobile = useMediaQuery('(max-width:1270px)');
    const isMobileee = useMediaQuery('(max-width:500px)');
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const account = useSelector(state => state.account.Account);
    const market = useSelector(state => state.account.market)

    useEffect(() => {
        dispatch(getAccount())
        dispatch(getAllMarketingData())
    }, []);

    const navigate = useNavigate()

    const handleEdit = (itemId, Dealer) => {
        navigate('/admin/add-account', { state: { mid: itemId, Dealerid: Dealer, isEdit: true, status: 'Complete' } });
    };

    const [selectedpdfOptions, setSelectedpdfOptions] = useState({});
    const [selectedStatus, setSelectedStatus] = useState("0");
    const [filteredMarketData, setFilteredMarketData] = useState([]);

    const handleOptionpdfChange = (event, id) => {
        setSelectedpdfOptions(prevOptions => ({
            ...prevOptions,
            [id]: event.target.value
        }));
    };

    const [marketdata, setMarketdata] = useState([]);

    useEffect(() => {
        const filteredData = market?.filter(v => {
            const dealer = v.dealerData?.[0]?.PaymentDetails;
            return dealer?.length > 0 && dealer !== undefined;
        });
        setMarketdata(filteredData);
    }, [market]);

    useEffect(() => {
        if (selectedStatus === "0") {
            setFilteredMarketData(marketdata);
        } else {
            const filtered = marketdata.filter(v => {
                console.log("v", v.TotalAmount)
                const dealerPaymentTotal = (Number(v.dealerData?.[0]?.PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0).toString();
                console.log("dealerTotal", dealerPaymentTotal)
                const dealerAccountTotal = (account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0).toString();
                console.log("AccountTotal", dealerAccountTotal)
                const pendingAmount = (v.TotalAmount - dealerAccountTotal).toString();
                console.log("pendingAmount", pendingAmount);


                if (selectedStatus === "Complete" && (v.TotalAmount < dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || v.TotalAmount === dealerPaymentTotal && v.TotalAmount === dealerAccountTotal || pendingAmount === 0)) {

                    return true;
                } else if (selectedStatus === "Partial-Pending" && (dealerPaymentTotal === dealerAccountTotal && pendingAmount > 0)) {
                    return true;
                } else if (selectedStatus === "Pending" && (pendingAmount > 0 && v.TotalAmount < dealerPaymentTotal !== dealerAccountTotal && dealerPaymentTotal !== dealerAccountTotal)) {
                    return true;
                }
                return false;
            });
            setFilteredMarketData(filtered);
        }
    }, [selectedStatus, marketdata, account]);

    const [statusCounts, setStatusCounts] = useState({ Pending: 0, 'Partial-Pending': 0, Complete: 0 });

    useEffect(() => {
        const counts = { Pending: 0, 'Partial-Pending': 0, Complete: 0 };

        market?.forEach(v => {
            const dealerPaymentTotal = Number(v.dealerData?.[0]?.PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0;
            const dealerAccountTotal = account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0;
            const pendingAmount = v.TotalAmount - dealerAccountTotal;
            if (v.TotalAmount - dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || v.TotalAmount === dealerPaymentTotal && v.TotalAmount === dealerAccountTotal || pendingAmount === 0) {
                counts.Complete++;
            } else if (dealerPaymentTotal === dealerAccountTotal && dealerPaymentTotal > 0) {
                counts['Partial-Pending']++;
            } else if (pendingAmount > 0 && v.TotalAmount < dealerPaymentTotal !== dealerAccountTotal && dealerPaymentTotal !== dealerAccountTotal) {
                counts.Pending++;
            }
        });

        setStatusCounts(counts);
    }, [market, account]);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [searchTerm, setSearchTerm] = useState('');

    const filteredData = useMemo(() => {
        return filteredMarketData?.filter(v => {
            // console.log("v", v)
            const totalPayment = v.TotalAmount.toString();
            const customerPayment = Number(v.dealerData?.[0]?.PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)).toString();
            const accountPayment = (() => {
                const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                return dealerAccount ? dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0).toString() : '0';
            })();
            const pendingPayment = (() => {
                const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                const dealerAccountTotal = dealerAccount ? dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) : 0;
                const pendingAmount = v.TotalAmount - dealerAccountTotal;
                return `${pendingAmount <= 0 ? '0' : pendingAmount}`;
            })();

            console.log("dddddddddddd", v.fillNo.toLowerCase().includes(searchTerm.toLowerCase()) ,
            v.MarketingType.toLowerCase().includes(searchTerm.toLowerCase()) ,
            v.ConsumerName.toLowerCase().includes(searchTerm.toLowerCase()) ,
            v.PhoneNumber.includes(searchTerm) ,
            v.SystemSizeKw.toString().includes(searchTerm) ,
            v.ConsumerNumber.toString().includes(searchTerm) ,
            v.userData?.[0]?.name.toLowerCase().includes(searchTerm.toLowerCase()) ,
            v.City_Village.toLowerCase().includes(searchTerm.toLowerCase()) ,
            totalPayment.includes(searchTerm) ,
            customerPayment.includes(searchTerm) ,
            accountPayment.includes(searchTerm) ,
            pendingPayment.includes(searchTerm),
            v.Dealer.toLowerCase(), searchTerm.toLowerCase(), v.userData?.[0]?.name
        );
            

            return (
                v.fillNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                v.MarketingType.toLowerCase().includes(searchTerm.toLowerCase()) ||
                v.ConsumerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                v.PhoneNumber.includes(searchTerm) ||
                v.SystemSizeKw.toString().includes(searchTerm) ||
                v.ConsumerNumber.toString().includes(searchTerm) ||
                v.userData?.[0]?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                v.City_Village.toLowerCase().includes(searchTerm.toLowerCase()) ||
                totalPayment.includes(searchTerm) ||
                customerPayment.includes(searchTerm) ||
                accountPayment.includes(searchTerm) ||
                pendingPayment.includes(searchTerm)
            );
        });
    }, [filteredMarketData, searchTerm, account]);

    return (

        <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
            <Header
                title="CUSTOMER PAYMENT"
                subtitle="Manage Your Customer Payment Here"
            />

            <Box sx={{ display: { xs: "block", md: "flex" }, justifyContent: 'space-between' }}>
                <FormControl size="small" sx={{ display: { xs: 'block', md: 'inline-flex' } }}>
                    <Select
                        value={selectedStatus}
                        onChange={(event) => {
                            setSelectedStatus(event.target.value);
                        }}
                        sx={{
                            minWidth: '100%',
                            [theme.breakpoints.up('sm')]: {
                                minWidth: '200px',
                            },
                            [theme.breakpoints.down('sm')]: {
                                minWidth: '100%',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        }}
                    >
                        <MenuItem value="0">Status ({marketdata?.length})</MenuItem>
                        <MenuItem value="Pending">Pending ({statusCounts?.Pending})</MenuItem>
                        <MenuItem value="Partial-Pending">Partial-Pending ({statusCounts['Partial-Pending']})</MenuItem>
                        <MenuItem value="Complete">Complete ({statusCounts.Complete})</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        minWidth: '100%',
                        mt: { xs: 2, md: 0 },
                        [theme.breakpoints.up('sm')]: {
                            minWidth: '300px',
                        },
                        [theme.breakpoints.down('sm')]: {
                            minWidth: '100%',
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#566585',
                            },
                            '&:hover fieldset': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        },
                    }}
                />
            </Box>



            {filteredData?.length > 0 ? (
                filteredData.map((v) => {
                    // console.log("v", v)
                    return (
                        <Box className="padding_box" sx={{
                            m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",
                            overflowX: 'auto',
                        }} key={v._id}
                        >
                            <Grid container item>
                                {!isMobile && (
                                    <Grid item sx={{ flexGrow: 1 }}>
                                        <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                                            <Box sx={{ width: '180px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>File no</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Market Type</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Name</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Contact No</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Consumer No</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>City/Village</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '300px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.fillNo}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.MarketingType}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.ConsumerName}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.PhoneNumber}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SystemSizeKw}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.ConsumerNumber}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.userData?.[0]?.name || v.userId}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.City_Village}</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '200px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Payment</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Payment</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Account Payment</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Pending Payment</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '200px' }}>
                                                <ul style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.TotalAmount}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{
                                                        Number(v.dealerData?.[0]?.PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0
                                                    }</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{(() => {
                                                        const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                                                        if (dealerAccount) {
                                                            return dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0);
                                                        }
                                                        return 0;
                                                    })()}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{(() => {
                                                        const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                                                        const dealerAccountTotal = dealerAccount ? dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) : 0;
                                                        const pendingAmount = v.TotalAmount - dealerAccountTotal;
                                                        return `${pendingAmount <= 0 ? '0' : pendingAmount}`;
                                                    })()}</li>
                                                </ul>
                                                {/* </Typography> */}
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1 }}>
                                                    <Box sx={{
                                                        mr: 2, padding: "8px 12px", borderRadius: '4px', color: "white",
                                                        backgroundColor: (() => {
                                                            const dealerPaymentTotal = Number(v.dealerData?.[0].PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0;
                                                            const dealerAccountTotal = account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0;
                                                            const pendingAmount = v.TotalAmount - dealerAccountTotal;

                                                            if (v.TotalAmount - dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || pendingAmount === 0) {
                                                                return '#2c742c';
                                                            } else if (dealerPaymentTotal === dealerAccountTotal) {
                                                                return '#a69041';
                                                            } else {
                                                                return '#9b2323';
                                                            }
                                                        })(),
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                    >
                                                        {(() => {
                                                            const dealerPaymentTotal = Number(v.dealerData?.[0].PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0;
                                                            // console.log("dealerPaymentTotal", dealerPaymentTotal)
                                                            const dealerAccountTotal = account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0;
                                                            // console.log("dealerAccountTotal", dealerAccountTotal)
                                                            const pendingAmount = v.TotalAmount - dealerAccountTotal;

                                                            if (v.TotalAmount - dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || v.TotalAmount === dealerPaymentTotal && v.TotalAmount === dealerAccountTotal || pendingAmount === 0) {
                                                                return 'Complete';
                                                            } else if (dealerPaymentTotal === dealerAccountTotal) {
                                                                return 'Partial-Pending';
                                                            } else if (pendingAmount > 0 && v.TotalAmount < dealerPaymentTotal !== dealerAccountTotal && dealerPaymentTotal !== dealerAccountTotal) {
                                                                return 'Pending';
                                                            }
                                                        })()}
                                                    </Box>
                                                    <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                        onClick={() => handleEdit(v._id, v.Dealer)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>

                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}
                                {isMobile ? (
                                    <>
                                        <Grid item>
                                            <Box sx={{ whiteSpace: 'pre-line', display: 'flex' }}>
                                                <Box sx={{ width: '180px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>File no</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Market Type</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Name</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Contact No</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Consumer No</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>City/Village</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '300px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.fillNo}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.MarketingType}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.ConsumerName}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.PhoneNumber}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SystemSizeKw}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.ConsumerNumber}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.userData?.[0]?.name || v.userId}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.City_Village}</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '200px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Payment</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Payment</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Account Payment</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Pending Payment</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '200px' }}>
                                                    <ul style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.TotalAmount}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{
                                                            Number(v.dealerData?.[0]?.PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0
                                                        }</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{(() => {
                                                            const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                                                            if (dealerAccount) {
                                                                return dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0);
                                                            }
                                                            return 0;
                                                        })()}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{(() => {
                                                            const dealerAccount = account.find(a => a.Dealer === v.Dealer);
                                                            const dealerAccountTotal = dealerAccount ? dealerAccount.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) : 0;
                                                            const pendingAmount = v.TotalAmount - dealerAccountTotal;
                                                            return `${pendingAmount <= 0 ? '0' : pendingAmount}`;
                                                        })()}</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ textAlign: 'right' }}>
                                                    <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                                                        <Box sx={{
                                                            mr: 2, padding: "8px 12px", borderRadius: '4px', color: "white",
                                                            backgroundColor: (() => {
                                                                const dealerPaymentTotal = Number(v.dealerData?.[0].PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0;
                                                                const dealerAccountTotal = account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0;
                                                                const pendingAmount = v.TotalAmount - dealerAccountTotal;

                                                                if (v.TotalAmount - dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || v.TotalAmount === dealerPaymentTotal && v.TotalAmount === dealerAccountTotal || pendingAmount === 0) {
                                                                    return '#2c742c';
                                                                } else if (dealerPaymentTotal === dealerAccountTotal) {
                                                                    return '#a69041';
                                                                } else {
                                                                    return '#9b2323';
                                                                }
                                                            })(),
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                        >
                                                            {(() => {
                                                                const dealerPaymentTotal = Number(v.dealerData?.[0].PaymentDetails?.reduce((total, payment) => total + Number(payment.PaymentAmount), 0)) || 0;
                                                                // console.log("dealerPaymentTotal", dealerPaymentTotal)
                                                                const dealerAccountTotal = account.find(a => a.Dealer === v.Dealer)?.AccountDetails?.reduce((total, acc) => total + Number(acc.AccountAmount), 0) || 0;
                                                                // console.log("dealerAccountTotal", dealerAccountTotal)
                                                                const pendingAmount = v.TotalAmount - dealerAccountTotal;

                                                                if (v.TotalAmount - dealerPaymentTotal && v.TotalAmount < dealerAccountTotal || v.TotalAmount === dealerPaymentTotal && v.TotalAmount === dealerAccountTotal || pendingAmount === 0) {
                                                                    return 'Complete';
                                                                } else if (dealerPaymentTotal === dealerAccountTotal) {
                                                                    return 'Partial-Pending';
                                                                } else if (v.TotalAmount < dealerPaymentTotal !== dealerAccountTotal && dealerPaymentTotal !== dealerAccountTotal) {
                                                                    return 'Pending';
                                                                }
                                                            })()}
                                                        </Box>
                                                        <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                            onClick={() => handleEdit(v._id, v.Dealer)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>

                                                    </Grid>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </>
                                ) : (
                                    <>

                                    </>
                                )}
                            </Grid>

                        </Box >
                    )
                })
            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found. Please Try a Different Filter Term.
                    </Typography>
                </Box>
            )}

        </Box >


    );
}

export default Account;
